// extracted by mini-css-extract-plugin
export default {"bubble-menu":"CE9vV","bubble-menu-group":"Ehih0","bubble-button":"Gm7XF","bubble-button-active":"EqAZ3","heading-dropdown":"TF0L6"};